import { render, staticRenderFns } from "./gdpr-modal-content.vue?vue&type=template&id=2f823757&lang=pug&"
import script from "./gdpr-modal-content.vue?vue&type=script&lang=js&"
export * from "./gdpr-modal-content.vue?vue&type=script&lang=js&"
import style0 from "./gdpr-modal-content.vue?vue&type=style&index=0&id=2f823757&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports